module.exports = __webpack_public_path__ + "media/theme/ogp-7bb4054b.png";